"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypeOverrides = void 0;
const pg_types_1 = require("pg-types");
const postgres_array_1 = require("postgres-array");
const createTypeOverrides = async (pool, typeParsers) => {
    const typeNames = typeParsers.map((typeParser) => {
        return typeParser.name;
    });
    const postgresTypes = (await pool.query('SELECT oid, typarray, typname FROM pg_type WHERE typname = ANY($1::text[])', [
        typeNames,
    ])).rows;
    const parsers = {};
    for (const typeParser of typeParsers) {
        const postgresType = postgresTypes.find((maybeTargetPostgresType) => {
            return maybeTargetPostgresType.typname === typeParser.name;
        });
        if (!postgresType) {
            throw new Error('Database type "' + typeParser.name + '" not found.');
        }
        parsers[postgresType.oid] = (value) => {
            return typeParser.parse(value);
        };
        if (postgresType.typarray) {
            parsers[postgresType.typarray] = (arrayValue) => {
                return (0, postgres_array_1.parse)(arrayValue)
                    .map((value) => {
                    return typeParser.parse(value);
                });
            };
        }
    }
    return (oid) => {
        if (parsers[oid]) {
            return parsers[oid];
        }
        return (0, pg_types_1.getTypeParser)(oid);
    };
};
exports.createTypeOverrides = createTypeOverrides;
